// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__AuYN-","modalForm":"UpgradeEpcsModal_modalForm__BNlcz","modalFooter":"UpgradeEpcsModal_modalFooter__1IO55"};